import { computed } from 'vue';
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import FormFieldCoordinator from './FormFieldCoordinator';

export default class TextInputFieldCoordinator extends FormFieldCoordinator {
  /** Compute the possibly empty placeholder text */
  private computePlaceholder() {
    const placeholder = computed(() =>
      this.field.value.displayVariantType === 'center-placeholder' ? this.field.value.name : ''
    );

    return placeholder;
  }

  setup() {
    const { htmlName } = this.field.value;
    let inputType: string;
    switch (htmlName) {
      case FieldHtmlNameUtil.email:
      case FieldHtmlNameUtil.referredEmail:
        inputType = 'email';
        break;
      default:
        inputType = 'text';
    }

    return {
      bubbleModel: this.buildBubbleModel(),
      placeholder: this.computePlaceholder(),
      inputType,
    };
  }
}
